const chargebeeSite = process.env.REACT_APP_CHARGEBEE_SITE || 'raydiant-test';
const chargebeeApiUrl = `https://${chargebeeSite}.chargebee.com`;
const appPreviewBlacklist: Record<string, string[]> = {
  iOS: ['News'],
};

if (!process.env.REACT_APP_LOGGLY_CUSTOMER_TOKEN) {
  throw new Error(
    'Missing environment variable: REACT_APP_LOGGLY_CUSTOMER_TOKEN',
  );
}

const config = {
  supportedDeviceModelsFor4K:
    process.env.REACT_APP_FEATURE_4K_SUPPORTED_DEVICE_MODELS,
  supportedDeviceModelsFor8K:
    process.env.REACT_APP_FEATURE_8K_SUPPORTED_DEVICE_MODELS,
  logglyCustomerToken: process.env.REACT_APP_LOGGLY_CUSTOMER_TOKEN,
  service: process.env.REACT_APP_SERVICE || 'raydiant-dash',
  environment: process.env.REACT_APP_ENVIRONMENT || 'local',
  revision: process.env.REACT_APP_REVISION,
  sessionCookieKey:
    process.env.REACT_APP_SESSION_COOKIE_KEY || 'raydiant-dash-session',
  miraApiUrl:
    process.env.REACT_APP_API_URL || 'https://auth.staging.displai.ai',
  disableFlushLogs:
    !process.env.REACT_APP_ENVIRONMENT ||
    process.env.REACT_APP_ENVIRONMENT === 'test' ||
    process.env.REACT_APP_ENVIRONMENT === 'local',
  disableConsoleLogs:
    process.env.REACT_APP_ENVIRONMENT === 'staging' ||
    process.env.REACT_APP_ENVIRONMENT === 'production',
  connectivityWizardPlaybookId: 43303,
  fileUploadPollMS: 5000,
  devicePublishPollMS: 5000,
  legacyMinDuration: 5,
  chargebeeSite,
  chargebeeApiUrl,
  SYBSoundZonePollMS: 60000,
  appPreviewBlacklist,
  auth0Domain: process.env.REACT_APP_AUTH0_DOMAIN || '',
  auth0ClientId: process.env.REACT_APP_AUTH0_CLIENT_ID || '',
  auth0DbConnection: process.env.REACT_APP_AUTH0_DB_CONNECTION || '',
  auth0Audience: process.env.REACT_APP_AUTH0_AUDIENCE || '',
  versionCookieKey:
    process.env.REACT_APP_VERSION_COOKIE_KEY || 'raydiant-dash-version',
  systemThemesProfileId: process.env.REACT_APP_SYSTEM_THEMES_PROFILE_ID,
  tikTokAppId: process.env.REACT_APP_TIKTOK_APP_ID,
  flyersAppId: process.env.REACT_APP_FLYERS_APP_ID,
  videosAppId: process.env.REACT_APP_VIDEOS_APP_ID,
  weatherAppId: process.env.REACT_APP_WEATHER_APP_ID,
  picturesAppId: process.env.REACT_APP_PICTURES_APP_ID,
  bluejeansAppId: process.env.REACT_APP_BLUEJEANS_APP_ID,
  pmwAppId: process.env.REACT_APP_PMW_APP_ID,
  instagramAppId: process.env.REACT_APP_INSTAGRAM_APP_ID,
  sybAppId: process.env.REACT_APP_SYB_APP_ID,
  spAppId: process.env.REACT_APP_SP_APP_ID,
  tbAppId: process.env.REACT_APP_TB_APP_ID,
  hooplaAppId: process.env.REACT_APP_HOOPLA_APP_ID,
  xiteAppId: process.env.REACT_APP_XITE_APP_ID,
  screenfeedAppId: process.env.REACT_APP_SCREENFEED_APP_ID,
  kioskAppId: process.env.REACT_APP_KIOSK_APP_ID,
  youtubeAppId: process.env.REACT_APP_YOUTUBE_APP_ID,
  presenterAppId: process.env.REACT_APP_PRESENTER_APP_ID,
  cloverAppId: process.env.REACT_APP_CLOVER_APP_ID,
  sentryDsn: process.env.REACT_APP_SENTRY_DSN,
  aiDashboardURL: process.env.REACT_APP_AI_DASHBOARD_URL,
  accountManagementUrl: process.env.REACT_APP_ACCOUNT_MANAGEMENT_URL,
  squareConnectorApiUrl: process.env.REACT_APP_SQUARE_CONNECTOR_API_URL || '',
  lightspeedConnectorApiUrl:
    process.env.REACT_APP_LIGHTSPEED_CONNECTOR_API_URL || '',
  supportAppUrl: process.env.REACT_APP_SUPPORT_URL,
  fontAppUrl: process.env.REACT_APP_FONT_URL,
  publicAssetUrl: process.env.REACT_APP_PUBLIC_ASSET_URL,
  productionBaseUrl: process.env.REACT_APP_PRODUCTION_BASE_URL,
  stagingBaseUrl: process.env.REACT_APP_STAGING_BASE_URL,
  dashboardUrl: process.env.REACT_APP_DASHBOARD_URL,
  officialWebsiteUrl:
    process.env.REACT_APP_MAIN_PAGE_URL || 'https://displai.ai',
  auth0CustomerNamespace: process.env.REACT_APP_AUTH0_CUSTOM_NAMESPACE,
  helpCenterUrl:
    process.env.REACT_APP_HELP_CENTER_URL || 'https://help.displai.ai',
  stripePublicKey:
    process.env.REACT_APP_STRIPE_PUBLIC_KEY ||
    'pk_test_51R1YquPuJCefzpgmKVoSPX6ACwGK6XCU7MyQqPqcp4CS11AWVGlmyIgq2qb1NX8hIZ2txj3YA1Io3d9vUOvalQxN00hnCHesVN',
  simplesatSurveyKey: process.env.REACT_APP_SIMPLESAT_SURVEY_KEY,
  // Per-app rollout allowlist for OAuth credential prefill, derived from the
  // per-app id env vars (so the right applications_v2 id is used per environment,
  // with no duplicated CSV). Add an app here to enable prefill/write/delete for
  // it. presenter is intentionally excluded (refresh-token rotation, H6).
  oauthPrefillAppIds: [
    process.env.REACT_APP_PMW_APP_ID,
    process.env.REACT_APP_INSTAGRAM_APP_ID,
  ].filter((id): id is string => Boolean(id)),
};

export default config;
